import { useEffect, useState } from 'react'

/**
 * 模块级共享 tick:同一 intervalMs 的所有订阅者共用一个 setInterval,
 * 每到点把该 interval 的计数 +1 并通知全部订阅者。用于"相对时间"这类
 * 需要定期重渲染但与网络无关的场景 —— 全局只 1 个定时器,O(订阅者) 通知。
 */
interface Bucket {
  timer: ReturnType<typeof setInterval>
  count: number
  subscribers: Set<(count: number) => void>
}
const buckets = new Map<number, Bucket>()

function subscribe(intervalMs: number, cb: (count: number) => void): () => void {
  let bucket = buckets.get(intervalMs)
  if (!bucket) {
    const b: Bucket = {
      count: 0,
      subscribers: new Set(),
      timer: setInterval(() => {
        b.count += 1
        b.subscribers.forEach(s => s(b.count))
      }, intervalMs),
    }
    buckets.set(intervalMs, b)
    bucket = b
  }
  bucket.subscribers.add(cb)
  return () => {
    const b = buckets.get(intervalMs)
    if (!b) return
    b.subscribers.delete(cb)
    if (b.subscribers.size === 0) {
      clearInterval(b.timer)
      buckets.delete(intervalMs)
    }
  }
}

export function useSharedTick(intervalMs: number): number {
  const [count, setCount] = useState(0)
  useEffect(() => subscribe(intervalMs, setCount), [intervalMs])
  return count
}
